<div id="popover-template" class="popover border-0 shadow-sm">
    <div class="popover-header fixed-top d-flex justify-content-between border-0 border-bottom align-items-center">
      <h6 class="mb-0">Explanation of CSV Fields in the Template</h6>
      <button type="button" class="btn btn-sm close popover-close" appButton>&times;</button>
    </div>
    <div class="popover-body table-responsive pt-0">
        <span>Showing <span class="h6 mb-0">{{templateFields?.length || 0}}</span> results </span>
        <table class="table table-sm table-hover">
        <thead class="sticky-top bg-white shadow-sm">
          <tr>
            <th>S No.</th>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
            <th>Mandatory</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of templateFields; let ind=index;">
            <td>{{ind + 1}}</td>
            <td class="field-wrap">{{field?.name}}</td>
            <td>{{field?.dataType}}</td>
            <td>{{field?.description || '-'}}</td>
            <td>{{field?.mandatory?.toString()?.toUpperCase() ?? "FALSE"}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

